// inv/src/service-scripts/gaContext.js
import { getStoredAttribution } from './attribution';

function getCookie(name) {
  return document.cookie
    .split('; ')
    .find(row => row.startsWith(name + '='))
    ?.split('=')[1];
}

function tryParseGA4Session(measurementId) {
  if (!measurementId) return { session_id: null, session_number: null };

  const cookies = [
    `_ga_${measurementId.replace('G-', '')}`,
    '_ga',
    '_ga_LCFCQBMHBX'
  ];

  for (const cookieName of cookies) {
    const val = getCookie(cookieName);
    if (!val) continue;

    const parts = val.split('.');
    if (parts.length >= 4) {
      const possibleSessionIds = [parts[2], parts[3], parts[4]];
      for (const id of possibleSessionIds) {
        const session_id = Number(id);
        if (Number.isFinite(session_id) && session_id > 1000000000) { // should be a reasonable timestamp
          return {
            session_id,
            session_number: Number(parts[3]) || 1
          };
        }
      }
    }
  }

  return { session_id: null, session_number: null };
}

export function getGAClientId(measurementId) {
  return new Promise((resolve) => {
    if (!window.gtag || !measurementId) return resolve(null);
    let settled = false;
    const finish = (value) => {
      if (settled) return;
      settled = true;
      resolve(value || null);
    };
    const timer = setTimeout(() => finish(null), 700);
    try {
      window.gtag('get', measurementId, 'client_id', (cid) => {
        clearTimeout(timer);
        finish(cid);
      });
    } catch {
      clearTimeout(timer);
      finish(null);
    }
  });
}

export async function collectGAContext() {
  const measurementId = window.GA_MEASUREMENT_ID || null;
  const client_id = await getGAClientId(measurementId);
  const { session_id, session_number } = tryParseGA4Session(measurementId);
  const attribution = getStoredAttribution();

  let fallbackSessionId = null;
  const gaCookie = getCookie('_ga');
  if (gaCookie) {
    const parts = gaCookie.split('.');
    if (parts.length >= 4) {
      fallbackSessionId = Number(parts[2]);
      if (!Number.isFinite(fallbackSessionId)) fallbackSessionId = null;
    }
  }

  let finalSessionId = session_id || fallbackSessionId;
  if (!finalSessionId) {
    finalSessionId = Math.floor(Date.now() / 1000);
  }

  let finalSessionNumber = session_number;
  if (!finalSessionNumber) {
    finalSessionNumber = 1;
  }

  return {
    client_id,
    session_id: finalSessionId,
    session_number: finalSessionNumber,
    attribution
  };
}
